import React, { Fragment, useState, useMemo, useEffect } from 'react';
import Select from '../../Select';

export default (props) => {
  const {
    answerHandlerOpen,
    errorMessage,
    onErrorMessageUpdate,
    maxTries,
    onMaxTriesUpdate,
    errorMessageFinal,
    onErrorMessageFinalUpdate,
    item,
    items,
    onSelect,
    hasValidationMessage,
    hasFinalMessage,
  } = props;

  const [isMessage, setIsMessage] = useState(!(item && item.conditionEscape));
  const [messageError, setMessageError] = useState(errorMessageFinal || '');
  const [selectedValue, setSelectedValue] = useState(null);

  const escapeOptions = useMemo(() => {
    return items
      ? items.map((_item) => ({
          value: _item._id,
          label: _item.title,
        }))
      : [];
  }, [items]);

  useEffect(() => {
    if (item && item.conditionEscape) {
      const destinationItem = items.find(
        (_item) => _item._id === item.conditionEscape
      );

      if (destinationItem) {
        setSelectedValue({
          value: destinationItem._id,
          label: destinationItem.title,
        });
      }
    } else {
      setSelectedValue(null);
    }
  }, [item]);

  useEffect(() => {
    if (item) {
      if (
        (errorMessageFinal && !item.conditionEscape) ||
        (!errorMessageFinal && !item.conditionEscape)
      ) {
        setIsMessage(true);
      }
      if (!errorMessageFinal && item.conditionEscape) {
        setIsMessage(false);
      }
    }
  }, [item?.conditionEscape]);

  useEffect(() => {
    if (errorMessageFinal) {
      setMessageError(errorMessageFinal);
    } else {
      setMessageError('');
    }
  }, [item, errorMessageFinal]);

  const handleSelect = (option) => {
    setSelectedValue(option);

    if (option) {
      onSelect({ conditionEscape: option.value });
    } else {
      onSelect({ conditionEscape: '' });
    }
  };

  const changeFinalizationType = (isMessage_) => {
    setIsMessage(isMessage_);
    if (isMessage_) {
      handleSelect(undefined);
    } else {
      onErrorMessageFinalUpdate('');
    }
  };

  return (
    <Fragment>
      <div>
        {hasValidationMessage && (
          <>
            <div
              className="form-group error-message-input-group mb-2"
              hidden={!answerHandlerOpen}
            >
              <label>Mensagem de erro de validação</label>
              <div>
                <textarea
                  id="error-errorMessage"
                  value={errorMessage || ''}
                  onChange={onErrorMessageUpdate}
                />
              </div>
            </div>
            <div
              className="form-group tries-amount mb-0"
              hidden={!answerHandlerOpen}
            >
              <span>Quantidade máx. de tentativas&nbsp;</span>
              <input
                type="number"
                id="error-maxtries"
                value={maxTries || ''}
                onChange={onMaxTriesUpdate}
              />
            </div>
          </>
        )}

        {hasFinalMessage && (
          <div
            className="form-group error-message-input-group mb-1"
            hidden={!answerHandlerOpen}
          >
            <>
              <label>Finalização</label>
              <br />
              <input
                id="mensagem"
                type="radio"
                name="finalization_type"
                checked={isMessage}
                onChange={() => changeFinalizationType(true)}
              />{' '}
              <label htmlFor="option1">Mensagem</label>
              <input
                id="bloco"
                type="radio"
                name="finalization_type"
                checked={!isMessage}
                onChange={() => changeFinalizationType(false)}
              />{' '}
              <label htmlFor="option2">Bloco</label>
            </>
            {isMessage ? (
              <>
                <label>Mensagem de finalização</label>
                <div>
                  <textarea
                    id="error-messagefinal"
                    value={errorMessageFinal || ''}
                    onChange={(e) => {
                      onErrorMessageFinalUpdate(e.target.value);
                    }}
                  />
                </div>
              </>
            ) : (
              <Select
                options={escapeOptions}
                getOptionLabel={(option) => `${option.label}: ${option.value}`}
                value={selectedValue}
                onChange={(value) => handleSelect(value)}
                isClearable
              />
            )}
          </div>
        )}
      </div>
    </Fragment>
  );
};
